


































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Mobile } from "@/mixins/mobile";

@Component
export default class AccordionSection extends Mixins(Mobile) {
  /**
   * Initial state, and a way in afterwards. `open` seeds `isOpen` once at
   * create so the user's own toggling is not fought by a static prop, but it
   * is also watched: a jump link that scrolls to a collapsed section has to be
   * able to reveal it, and before this the section could only be opened by
   * clicking its own title.
   *
   * Raising `open` opens the section; lowering it is ignored, so a parent can
   * reveal a section without yanking one shut under the user.
   */
  @Prop({ default: false }) readonly open!: boolean;
  protected isOpen = false;

  created() {
    this.isOpen = this.open;
  }

  @Watch("open")
  protected onOpenChange(open: boolean): void {
    if (open) this.isOpen = true;
  }

  /** Imperative equivalent, for callers holding a ref rather than a prop. */
  public expand(): void {
    this.isOpen = true;
  }

  toggle() {
    this.isOpen = !this.isOpen;
  }
}
